import React from "react";
import { useI18n } from "../../lib/i18n";
import { CheckCircle } from "@phosphor-icons/react";

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1642522029691-029b5a432954?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

export default function About() {
  const { t } = useI18n();

  return (
    <section
      id="about"
      data-testid="about-section"
      className="bg-[#F8F9FA] py-24 lg:py-32"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          {/* Image */}
          <div className="lg:col-span-5 order-2 lg:order-1">
            <div className="relative">
              <div className="absolute -top-6 -left-6 w-24 h-24 border border-[#C5A059] z-0" />
              <div className="relative z-10 img-zoom">
                <img
                  src={ABOUT_IMG}
                  alt="Studio Makelaars360"
                  className="w-full h-[500px] object-cover"
                />
              </div>
              <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-[#C5A059] z-0 hidden md:block" />
            </div>
          </div>

          {/* Content */}
          <div className="lg:col-span-7 order-1 lg:order-2">
            <p className="overline mb-5">{t.about.overline}</p>
            <h2 className="font-serif text-4xl lg:text-5xl xl:text-6xl text-[#0A1428] leading-[1.1] tracking-tight font-medium">
              {t.about.title}
            </h2>
            <p className="mt-7 text-[#4A5568] text-lg leading-relaxed">
              {t.about.paragraph1}
            </p>
            <p className="mt-5 text-[#4A5568] text-base leading-relaxed">
              {t.about.paragraph2}
            </p>
            <p className="mt-5 text-[#4A5568] text-base leading-relaxed">
              {t.about.paragraph3}
            </p>

            <ul className="mt-8 space-y-3">
              {[t.about.bullet1, t.about.bullet2, t.about.bullet3, t.about.bullet4].map((b, i) => (
                <li key={i} className="flex items-start gap-3 text-[#0A1428]">
                  <CheckCircle size={22} weight="duotone" className="text-[#C5A059] flex-shrink-0 mt-0.5" />
                  <span className="font-medium">{b}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
